/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';
import type { Program } from './Program';
import {
    ProgramFromJSON,
    ProgramFromJSONTyped,
    ProgramToJSON,
} from './Program';

/**
 * 
 * @export
 * @interface PageablePrograms
 */
export interface PageablePrograms {
    /**
     * 
     * @type {Array<Program>}
     * @memberof PageablePrograms
     */
    result: Array<Program>;
    /**
     * 
     * @type {Page}
     * @memberof PageablePrograms
     */
    page: Page;
}

/**
 * Check if a given object implements the PageablePrograms interface.
 */
export function instanceOfPageablePrograms(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableProgramsFromJSON(json: any): PageablePrograms {
    return PageableProgramsFromJSONTyped(json, false);
}

export function PageableProgramsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageablePrograms {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(ProgramFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableProgramsToJSON(value?: PageablePrograms | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(ProgramToJSON)),
        'page': PageToJSON(value.page),
    };
}

